const BASE_URL = 'http://127.0.0.1:5000/returns3';

async function upload(url, formData, fileName, fileType){

  // using fetch here beacuse AWS requires to set correct content-type
  const res = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": fileType
        },
        body: formData
    })

    return res

    // const headers = { 'ContentType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'};
    // return axios.put(url, formData, {headers})
    //     .then(x => console.log(x));
      
    // return axios({
        //     url: url,
        //     method: 'put',
        //     headers: {'ContentType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
        //     data: formData
        // })
}

export {upload}